import { useContext } from 'react';
import IntegrationsTable from '../../../components/IntegrationsTable';
import { DashboardContext } from '../../../contexts/DashboardContext';

export const ManageDynamicPageSettingsIntegrations = () => {
  const { selectedDynamicPage } = useContext(DashboardContext);

  return <IntegrationsTable dynamicPageId={selectedDynamicPage?.id} />;
};
